import { render } from "./Column202310.vue?vue&type=template&id=3561d8c5&scoped=true"
import script from "./Column202310.vue?vue&type=script&lang=js"
export * from "./Column202310.vue?vue&type=script&lang=js"

import "./Column202310.vue?vue&type=style&index=0&id=3561d8c5&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3561d8c5"]])

export default __exports__